<template>
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      :name="name"
      :id="id"
      :value="value"
      :checked="checked"  
      @change="handleChange" 
    />
    <label :for="id" class="custom-control-label">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "argon-checkbox",
  props: {
    name: String,
    id: String,
    checked:Boolean,
    value: [String, Number],  // El valor que representa el ID del proceso
    modelValue: [String, Number, Array]  // Puede ser un valor, número o un array
  },
  emits: ['update:modelValue'],  // Emitimos el cambio del modelo
  methods: {
    handleChange(event) {
      const isChecked = event.target.checked;
      if (isChecked) {
        this.$emit('update:modelValue', [...this.modelValue, this.value]);
      } else {
        this.$emit('update:modelValue', this.modelValue.filter(id => id !== this.value));
      }
    }
  }
};
</script>
